import * as z from "zod";

export { updateDisplayNameInputSchema } from "@dailywars/core/displayNameValidation";

export const updateGameplaySettingInputSchema = z.object({
  setting: z.enum(["endTurnConfirmation", "fastAnimations", "disableAiPlayback"]),
  enabled: z.boolean(),
});
